import { Component, inject } from '@angular/core';
import { Breadcrumb } from '@spartacus/core';
import { ActiveFacetsComponent } from '@spartacus/storefront';
import { HisenseFacetService } from '../../../../features/services/facet.service';

@Component({
  selector: 'cx-active-facets',
  templateUrl: './active-facets.component.html',
  styleUrls: ['./active-facets.component.scss'],
  standalone: false,
})
export class HisenseActiveFacetsComponent extends ActiveFacetsComponent {
  protected override facetService = inject(HisenseFacetService);
  // override facetList$: Observable<FacetList> = this.facetService.facetList$;

  override getLinkParams(facet: Breadcrumb) {
    return this.facetService.getLinkParams(facet.removeQuery?.query?.value!);
  }
}
